import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable, } from '@angular/core';
import {Observable} from 'rxjs';

import { environment } from '@environments/environment';
import { EMPTY } from '@utils';

export interface IRequestOptions {
  headers?: HttpHeaders;
  observe?: any;
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: any;
  withCredentials?: boolean;
  body?: any;
}

export function applicationHttpClientCreator(http: HttpClient) {
  return new ApplicationHttpClient(http);
}

@Injectable()
export class ApplicationHttpClient {
  private api = environment.apiUrl;

  public constructor(
    public http: HttpClient,
  ) {
    // If you don't want to use the extended versions in some cases you can access the public property and use the original one.
    // for ex. this.httpClient.http.get(...)
  }

  /**
   * GET request
   * @param <string>          endPoint it doesn't need / in front of the end point
   * @param <IRequestOptions> options options of the request like headers, body, etc.
   * @returns (Observable<T>)
   */
  public Get<T>(endPoint: string, options?: IRequestOptions): Observable<T> {
    // console.log(endPoint);
    return this.http.get<T>(this.api + endPoint, this.setRequestOptions(options));
  }

  /**
   * POST request
   * @param <string>          endPoint end point of the api
   * @param <Object>          params body of the request.
   * @param <IRequestOptions> options options of the request like headers, body, etc.
   * @returns (Observable<T>)
   */
  public Post<T>(endPoint: string, body: Object, options?: IRequestOptions): Observable<T> {
    // console.log(endPoint);
    return this.http.post<T>(this.api + endPoint, body, this.setRequestOptions(options));
  }

  /**
   * PUT request
   * @param <string>          endPoint end point of the api
   * @param <Object> params   body of the request.
   * @param <IRequestOptions> options options of the request like headers, body, etc.
   * @returns (Observable<T>)
   */
  public Put<T>(endPoint: string, params: Object, options?: IRequestOptions): Observable<T> {
    return this.http.put<T>(this.api + endPoint, params, this.setRequestOptions(options));
  }

  /**
   * DELETE request
   * @param <string>          endPoint end point of the api
   * @param <IRequestOptions> options options of the request like headers, body, etc.
   * @returns (Observable<T>)
   */
  public Delete<T>(endPoint: string, options?: IRequestOptions): Observable<T> {
    return this.http.delete<T>(this.api + endPoint, this.setRequestOptions(options));
  }

  private formattedParams(httpParams: any = null) {
    let params: object = {};

    if (httpParams !== null) {
      Object.keys(httpParams).map((key) => {
        if (key !== 'ordering') {
          params = {...params, [key]: httpParams[key]};
        } else if (key === 'ordering') {
          Array.from(httpParams['ordering']).map((value) => {
            params = {...params, ordering: value};
          });
        }
      });
      // console.log('params', params);
    }

    return httpParams;
  }

  private setRequestOptions(httpParams: any = null, isResponseType = false): IRequestOptions {
    /*
      esto es para fijar el RESPONSE_TYPE = blob ... en la constante <requestOptionParams>
      utilizado para el GET de imagenes de tableau en WorkBookService...
    */
    let rt = '';
    if (httpParams !== EMPTY) {
      rt = (httpParams.hasOwnProperty('responseType')) ? httpParams['responseType'] : EMPTY;
    }
    // -------------------------------------------------------------------------------------

    const token  = localStorage.getItem('token') || '';
    // console.log(localStorage.getItem('token'));
    const headers = {
      'Content-Type':  'application/json',
      'Authorization': (token) ? `Bearer ${token}` : '',
    };

    if (headers['Authorization'] === '') {
      delete headers['Authorization'];
    }

    const requestOptionParams: IRequestOptions = {
      headers: new HttpHeaders(headers),
      params: httpParams,
      responseType: rt,
    };
    if (requestOptionParams.responseType === EMPTY) {delete requestOptionParams['responseType']; }

    if (isResponseType) {
      requestOptionParams.observe = 'response';
    }

    return requestOptionParams;
  }

  public Ping<T>(options?: IRequestOptions): Observable<T> {
    return this.http.get<T>(this.api, this.setRequestOptions(options, true));
  }

  public RefreshToken<T>(payload: object): Observable<T> {
    if (payload['token'] !== EMPTY) {
      return this.http.post<T>(
        `${this.api}api-token-refresh/`,
        payload,
      );
    } else {
      return null;
    }
  }
}
